import React, { useEffect } from "react";
import UtilisationIndicator from "./UtilisationIndicator";
import UtilisationAmStripChart from "./UtilisationAmStripChart";
import HeatBand from "./HeatBand";

export default function DeskPopup({ desk, onClose }) {
  if (!desk) return null;

  const { code, stats } = desk;

  // Close on outside click
  useEffect(() => {
    function handleClick(e) {
      const el = document.getElementById("desk-popup-card");
      if (!el) return;

      if (!el.contains(e.target)) {
        onClose && onClose();
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [onClose]);

  const popupStyle = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 999999,

    // 🔥 WHITE OUTER
    background: "#ffffff",

    borderRadius: "16px",
    border: "1px solid rgba(0,0,0,0.06)",

    boxShadow:
      "0 18px 50px rgba(0,0,0,0.25), 0 6px 16px rgba(0,0,0,0.15)",

    padding: "18px 20px",
    width: "440px",

    opacity: 0,
    animation: "popupFadeIn 0.22s ease forwards"
  };

  const closeBtn = {
    position: "absolute",
    top: "8px",
    right: "10px",
    width: "20px",
    height: "20px",
    cursor: "pointer",
    fontSize: "18px",
    lineHeight: "20px",
    color: "#666",
    textAlign: "center"
  };

  return (
    <>
      <style>{`
        @keyframes popupFadeIn {
          0% { opacity: 0; transform: translate(-50%, -55%); }
          100% { opacity: 1; transform: translate(-50%, -50%); }
        }
      `}</style>

      <div id="desk-popup-card" style={popupStyle}>
        
        {/* Close */}
        <div style={closeBtn} onClick={onClose}>×</div>

        {/* TITLE */}
        <div style={{
          fontSize: "18px",
          fontWeight: "600",
          marginBottom: "10px",
          color: "#111827"
        }}>
          {code}
        </div>

        {/* KPI PANEL */}
        <div style={{
          padding: "14px",
          background: "#0f172a",
          borderRadius: "12px",
          boxShadow: "0 6px 18px rgba(0,0,0,0.25)",
          marginBottom: "12px"
        }}>
          <UtilisationIndicator
            title="Average Utilisation"
            percentage={stats.avg}
            maxValue={stats.max}
            maxDate={stats.maxDate}
            minValue={stats.min}
            minDate={stats.minDate}
            darkMode={true}
          />
        </div>

        {/* TIMELINE PANEL */}
        <div style={{
          padding: "12px",
          background: "#0f172a",
          borderRadius: "12px",
          boxShadow: "0 6px 18px rgba(0,0,0,0.25)",

          display: "flex",
          flexDirection: "column",
          gap: "2px"
        }}>

          {/* Chart */}
          <div style={{ display:'flex', height: "120px" }}>
            <UtilisationAmStripChart
              data={stats.numericSeries}
            />
          </div>

          {/* Heatband */}
          <div style={{ height: "10px" }}>
            <HeatBand
              data={stats.numericSeries}
              darkMode={true}
            />
          </div>

        </div>

      </div>
    </>
  );
}